const DEFAULT_COLOR = '#0060EE'
const TINT_RATIO = 0.88

function parseHex (hex) {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex || '')
  if (!match) return null
  const int = parseInt(match[1], 16)

  return {
    r: (int >> 16) & 0xff,
    g: (int >> 8) & 0xff,
    b: int & 0xff
  }
}

function mixWithWhite (hex, ratio) {
  const rgb = parseHex(hex)
  if (!rgb) return hex
  const mix = (channel) => Math.round(channel * (1 - ratio) + 255 * ratio)

  return '#' + [mix(rgb.r), mix(rgb.g), mix(rgb.b)]
    .map(v => v.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()
}

export default {
  install (Vue, { store, vuetify }) {
    const apply = (color) => {
      const value = color || DEFAULT_COLOR
      const light = mixWithWhite(value, TINT_RATIO)
      const rgb = parseHex(value)
      document.documentElement.style.setProperty('--color-primary', value)
      document.documentElement.style.setProperty('--color-primary-light', light)
      if (rgb) {
        document.documentElement.style.setProperty('--color-primary-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`)
      }
      if (vuetify && vuetify.framework && vuetify.framework.theme) {
        vuetify.framework.theme.themes.light.primary = value
      }
    }

    apply(store.getters['appSettings/effectiveColor'])

    store.watch(
      (_, getters) => getters['appSettings/effectiveColor'],
      apply
    )
  }
}
